// Simple solution using browser alerts when no toast system is available
export const showSessionExpiredNotification = () => {
    // Fallback to alert for session expiry notification
    alert("Your session has expired. Please sign in again.");
  };